import { Artist, ArtistRegisterStatus } from '@favid-inc/api';
import { Action } from 'core/generic';
import { Modal } from 'core/modal';
import { updateArtist } from 'features/artist';
import React from 'react';
import styled from 'styled-components';
import { EmptyList } from 'utils/GenericCompoents';

interface Props {
  artist: Artist;
  onUpdateArtist: (action: Action) => void;
  onClose: () => void;
}

class ConfirmDenyRegisterComponent extends React.Component<Props> {
  onConfirmDenyRegister = () => {
    const { artist, onUpdateArtist } = this.props;
    artist.registerStatus = ArtistRegisterStatus.DENIED;
    if (onUpdateArtist) {
      updateArtist(artist, onUpdateArtist);
    }
    this.props.onClose();
  };

  renderActions() {
    return (
      <div className='buttons'>
        <div className='ui button' onClick={this.props.onClose}>
          Cancelar
        </div>
        <div className='ui button negative' onClick={this.onConfirmDenyRegister}>
          Negar cadastro
        </div>
      </div>
    );
  }

  renderContent() {
    const { name, email, biography, photoUri } = this.props.artist;

    return (
      <div>
        <div className='ui cards'>
          <Card className='card'>
            <div className='content'>
              <img className='right floated mini ui image' alt={name} src={photoUri} />
              <div className='header'>{name}</div>
              <div className='meta'>{email}</div>
              <div className='description'>{biography}</div>
            </div>
          </Card>
        </div>
        <EmptyList message='esta ação não poderá ser desfeita.' />
      </div>
    );
  }

  render() {
    return (
      <Modal
        header='Confirmar negação de cadastro'
        content={this.renderContent()}
        actions={this.renderActions()}
        isOpen={true}
        handleClose={this.props.onClose}
      />
    );
  }
}

export const ConfirmDenyRegister = ConfirmDenyRegisterComponent;

const Card = styled.div`
  margin: 1em auto !important;
`;
